import apiClient from '@/lib/axios'

export const getUserByToken = async (): Promise<User> => {
  const response = await apiClient.get('/users')
  return response.data
}

export const getUsersByOrganization = async (
  payload: getUsersByOrganizationPayload
): Promise<getUsersByOrganizationResponse> => {
  const response = await apiClient.get('/users/organization', {
    params: payload,
  })
  return response.data
}

export const updateUser = async (body: updateUserPayload): Promise<User> => {
  const response = await apiClient.patch('/users/update', {
    ...body,
  })
  return response.data
}
